"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Update reward adjustment item to match new quantity
 * @param event event of type UpdateRewardItemEvent
 * @param prevState previous order state
 */
function default_1(event, prevState = {}) {
    var _a, _b, _c, _d;
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    if (event.productId && event.itemQuantity) {
        // split the case of updating itemQuantity
        const orderItems = (_a = order.orderItems) === null || _a === void 0 ? void 0 : _a.filter(item => {
            var _a;
            return (item.product.id === event.productId ||
                ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.id) === event.productId) &&
                !domain_1.EXCLUDED_ITEM_STATUSES.includes(item.status);
        });
        let remainingQuantity = event.itemQuantity;
        let clonedReward;
        orderItems.forEach(item => {
            var _a;
            const applyQuantity = remainingQuantity > item.quantity ? item.quantity : remainingQuantity;
            if (applyQuantity) {
                // update
                const reward = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a.find(adj => adj.id === event.rewardId &&
                    adj.adjustmentType === domain_1.AdjustmentType.REWARD);
                if (!clonedReward && reward) {
                    clonedReward = (0, utils_1.clone)(reward);
                }
                if (reward) {
                    // reward exists, update itemQuantity
                    reward.itemQuantity = applyQuantity;
                }
                else {
                    // reward does not exist, clone from other reward and apply new quantity
                    item.adjustments = [{ ...clonedReward, itemQuantity: applyQuantity }];
                }
            }
            else {
                // remove
                item.adjustments = (item.adjustments || []).filter(adj => adj.id !== event.rewardId);
            }
            item.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(item);
            remainingQuantity = remainingQuantity - applyQuantity;
        });
    }
    else {
        const orderItem = event.productId
            ? (_b = order.orderItems) === null || _b === void 0 ? void 0 : _b.find(item => {
                var _a;
                return (item.product.id === event.productId ||
                    ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.id) === event.productId) &&
                    !domain_1.EXCLUDED_ITEM_STATUSES.includes(item.status);
            })
            : undefined;
        const reward = (_d = (_c = (event.productId ? orderItem : order)) === null || _c === void 0 ? void 0 : _c.adjustments) === null || _d === void 0 ? void 0 : _d.find(adj => adj.id === event.rewardId &&
            adj.adjustmentType === domain_1.AdjustmentType.REWARD);
        if (!reward) {
            return order;
        }
        reward.quantity = event.quantity;
        if (orderItem) {
            orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
        }
    }
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=updateRewardItem.js.map